import { render } from "./ProgressPage.vue?vue&type=template&id=e1560e5a"
import script from "./ProgressPage.vue?vue&type=script&lang=js"
export * from "./ProgressPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__